import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const LotCategoryDialogTourConfig: AgTechTourConfig = {
    id: 'lot-category-dialog-tour',
    name: 'Lot Category Tour',
    steps: [
        {
            targetId: 'lot-category-name',
            title: 'Name and Color',
            description: 'Name the category and pick a color. The color is used to tag lots in this category so they are easy to spot in grids.',
            position: 'bottom',
        },
        {
            targetId: 'lot-category-description',
            title: 'Description',
            description: 'Optionally describe what belongs in this category, such as breed, class or weight range.',
            position: 'top',
        },
    ]
}
